(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["socket-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const cartItems = document.getElementById('cart-items');
    const cartItemsMobile = document.getElementById('cart-mobile');
    const subtotalDisplay = document.getElementById('subtotal');

    if (window.matchMedia('(max-width: 768px)').matches) {
      console.log(cartItemsMobile);
      cartItemsMobile.addEventListener('click', function (event) {
        if (event.target.classList.contains('quantity-btn')) {
          const action = event.target.getAttribute('data-action');
          const itemKey = event.target.getAttribute('data-id');
          let quantitySpan = event.target.parentElement.querySelector('.quantity');
          let quantity = parseInt(quantitySpan.textContent);

          if (action === 'increase') {
            quantity++;
          } else if (action === 'decrease' && quantity > 1) {
            quantity--;
          }

          updateCartQuantity(itemKey, quantity);
        }
      });
    } else {
      // Handle quantity changes
      cartItems.addEventListener('click', function (event) {
        if (event.target.classList.contains('quantity-btn')) {
          const action = event.target.getAttribute('data-action');
          const itemKey = event.target.getAttribute('data-id');
          let quantitySpan = event.target.parentElement.querySelector('.quantity');
          let quantity = parseInt(quantitySpan.textContent);

          if (action === 'increase') {
            quantity++;
          } else if (action === 'decrease' && quantity > 1) {
            quantity--;
          }

          updateCartQuantity(itemKey, quantity);
        }
      });
    }

    // Handle item removal
    let removeButtons = document.querySelectorAll('.remove-btn');
    removeButtons.forEach((el) => {
      el.addEventListener('click', () => {
        const itemKey = el.dataset.id;
        removeCartItem(itemKey);
      });
    });

    // cartItems.addEventListener('click', function (event) {
    //   if (event.target.classList.contains('remove-btn')) {
    //     const itemKey = event.target.getAttribute('data-id');
    //     removeCartItem(itemKey);
    //   }
    // });

    // Update the cart quantity
    function updateCartQuantity(itemKey, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Cart updated:', data);
          updateCartDisplay(data);
        })
        .catch((error) => console.error('Error updating cart:', error));
    }

    // Remove an item from the cart
    function removeCartItem(itemKey) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: itemKey, // Make sure this is the line item key
          quantity: 0, // Set quantity to 0 to remove the item
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Item removed:', data);
          updateCartDisplay(data);
        })
        .catch((error) => console.error('Error removing item:', error));
    }

    // Update the cart display after changes
    function updateCartDisplay(cartData) {
      // Clear existing cart items
      if (window.matchMedia('(max-width: 768px)').matches) {
        console.log(cartItemsMobile);
        cartItemsMobile.innerHTML = '';

        cartData.items.forEach((item) => {
          cartItemsMobile.innerHTML = `<div class="cart-mobile__item">
          <div class="cart-mobile__item-image">
            <img src="${item.featured_image.url}">
          </div>
          <div class="cart-mobile__item-wrapper">
            <div class="cart-mobile__item-title">${item.product_title}</div>
            <div class="quantity-buttons">
              <button type="button" class="quantity-btn" data-action="decrease" data-id="${item.id}">-</button>
              <span class="quantity">${item.quantity}</span>
              <button type="button" class="quantity-btn" data-action="increase" data-id="{{ item.id }}">+</button>
            </div>
          </div>
          <div class="cart-mobile__item-wrapper">
            <button class="remove-btn" data-id="${item.key}">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00195 8.00984C8.61142 7.61932 8.61142 6.98615 9.00195 6.59563L13.4559 2.14166C13.7293 1.86829 13.7293 1.42508 13.4559 1.15171C13.1825 0.878346 12.7393 0.878346 12.466 1.15171L8.012 5.60568C7.62147 5.9962 6.98831 5.9962 6.59778 5.60568L2.14313 1.15102C1.86976 0.877654 1.42654 0.877654 1.15318 1.15102C0.879811 1.42439 0.879811 1.8676 1.15318 2.14097L5.60784 6.59563C5.99836 6.98615 5.99836 7.61932 5.60784 8.00984L1.15225 12.4654C0.878886 12.7388 0.878886 13.182 1.15225 13.4554C1.42562 13.7287 1.86884 13.7287 2.1422 13.4554L6.59778 8.99979C6.98831 8.60927 7.62147 8.60927 8.012 8.99979L12.4669 13.4547C12.7403 13.728 13.1835 13.728 13.4568 13.4547C13.7302 13.1813 13.7302 12.7381 13.4568 12.4647L9.00195 8.00984Z" fill="#1F1C1C" />
              </svg>
            </button>
            <span class="item-subtotal">${(item.line_price / 100).toFixed(2)}</span>
          </div>
        </div>`;
          cartItemsMobile.insertAdjacentHTML('beforeend', itemRow);
        });
      } else {
        // Re-populate cart items
        cartData.items.forEach((item) => {
          const itemRow = `
                <tr data-item-id="${item.key}">
                    <td class="cart-items__image"><img src="${item.featured_image.url}"></td>
                    <td class="cart-items__title">${item.product_title}</td>
                    <td>${(item.price / 100).toFixed(2)}</td>
                    <td>
                        <button type="button" class="quantity-btn" data-action="decrease" data-id="${item.key}">-</button>
                        <span class="quantity">${item.quantity}</span>
                        <button type="button" class="quantity-btn" data-action="increase" data-id="${item.key}">+</button>
                    </td>
                    <td class="item-subtotal">${(item.line_price / 100).toFixed(2)}</td>
                    <td>
                        <button class="remove-btn" data-id="${item.key}">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00195 8.00984C8.61142 7.61932 8.61142 6.98615 9.00195 6.59563L13.4559 2.14166C13.7293 1.86829 13.7293 1.42508 13.4559 1.15171C13.1825 0.878346 12.7393 0.878346 12.466 1.15171L8.012 5.60568C7.62147 5.9962 6.98831 5.9962 6.59778 5.60568L2.14313 1.15102C1.86976 0.877654 1.42654 0.877654 1.15318 1.15102C0.879811 1.42439 0.879811 1.8676 1.15318 2.14097L5.60784 6.59563C5.99836 6.98615 5.99836 7.61932 5.60784 8.00984L1.15225 12.4654C0.878886 12.7388 0.878886 13.182 1.15225 13.4554C1.42562 13.7287 1.86884 13.7287 2.1422 13.4554L6.59778 8.99979C6.98831 8.60927 7.62147 8.60927 8.012 8.99979L12.4669 13.4547C12.7403 13.728 13.1835 13.728 13.4568 13.4547C13.7302 13.1813 13.7302 12.7381 13.4568 12.4647L9.00195 8.00984Z" fill="#1F1C1C" />
                            </svg>
                        </button>
                    </td>
                </tr>
            `;
          cartItems.insertAdjacentHTML('beforeend', itemRow);
        });
      }
      // Update the subtotal
      subtotalDisplay.textContent = `${(cartData.total_price / 100).toFixed(2)}`;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["socket-contact"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      var form = document.getElementById('contactForm');
      var submitButton = document.getElementById('submitBtn');
  
      form.addEventListener('submit', function () {
        submitButton.innerText = 'Sending...'; // Change button text while sending
      });
  
      // Check if the form was successfully submitted
      if (window.location.hash === '#contact_form') {
        submitButton.innerText = 'Message successfully sent!';
      }
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["socket-hero"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', videoScroll);
  window.addEventListener('scroll', videoScroll);

  function videoScroll() {
    if (document.querySelectorAll('video[autoplay]').length > 0) {
      var windowHeight = window.innerHeight,
        videoEl = document.querySelectorAll('video[autoplay]');

      for (var i = 0; i < videoEl.length; i++) {
        var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;

        if (videoClientRect <= windowHeight - videoHeight * 0.5 && videoClientRect >= 0 - videoHeight * 0.5) {
          thisVideoEl.play();
        } else {
          thisVideoEl.pause();
        }
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["socket-instalation"] && !Shopify.designMode) return;
  try {
     
  document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(max-width: 768px)').matches) {
        let button = document.querySelector('.instalation__text-title .feature-button');
        let newContainer = document.querySelector('.instalation__text-subtitle');
        newContainer.insertAdjacentElement('beforeend', button);
    }


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["socket-video"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', videoScroll);
  window.addEventListener('scroll', videoScroll);

  function videoScroll() {
    if (document.querySelectorAll('video[autoplay]').length > 0) {
      var windowHeight = window.innerHeight,
        videoEl = document.querySelectorAll('video[autoplay]');

      for (var i = 0; i < videoEl.length; i++) {
        var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;

        if (videoClientRect <= windowHeight - videoHeight * 0.5 && videoClientRect >= 0 - videoHeight * 0.5) {
          thisVideoEl.play();
        } else {
          thisVideoEl.pause();
        }
      }
    }
  }

  } catch(e) { console.error(e); }
})();
})();
